import React, { FC, useState } from "react";
import { Link, Stack, Typography } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

import { MenuLink } from "@src/types";
import { Colors } from "@theme/colors";
import { Arrow, navArrowHoverStyles } from "./arrow";
import { ArrowDropUpRounded } from "@mui/icons-material";

interface Props {
  menuLinks: Array<MenuLink>;
}

interface ItemProps {
  item: MenuLink;
}

const DropdownLink: FC<ItemProps> = ({ item }) => {
  const currentPath = window.location.pathname;
  const [textColor, setTextColor] = useState<string>(Colors.HeadingText);
  const [iconColor, setIconColor] = useState<string>(Colors.PrimaryMain);

  const mouseOverHandler = () => {
    setTextColor(Colors.InfoMain);
    setIconColor(Colors.InfoMain);
  };

  const mouseOutHandler = () => {
    setTextColor(Colors.HeadingText);
    setIconColor(Colors.PrimaryMain);
  };

  return (
    <Link
      href={item.type === "disabled" ? undefined : item.link}
      target={item.type === "external" ? "_new" : undefined}
      sx={{
        padding: "0",
        textDecoration: "none",
        width: "100%",
        "&:hover": {
          ...navArrowHoverStyles,
        },
      }}
      onMouseOver={mouseOverHandler}
      onMouseLeave={mouseOutHandler}
    >
      <Stack direction="row" alignItems="center">
        <Typography
          variant="overline"
          sx={{
            color:
              item.type === "disabled" ? Colors.BodyText : Colors.HeadingText,
            fontSize: "14px",
            marginBottom: "0px",
            fontWeight: "600",
          }}
        >
          {item.name} <Arrow />
        </Typography>
      </Stack>
    </Link>
  );
};

const DropdownMenu: FC<Props> = ({ menuLinks }) => {
  return (
    <Stack
      gap="16px"
      sx={{
        minWidth: "200px",
        marginTop: "15px",
        marginLeft: "-60px",
        position: "relative",
        padding: "32px",
        borderRadius: "12px",
        backgroundColor: Colors.PrimaryContrast,
        boxShadow: "0px 0px 20px rgba(50, 50, 93, 0.25)",
      }}
    >
      <ArrowDropUpRounded
        fontSize="large"
        sx={{
          position: "absolute",
          top: "-33px",
          zIndex: 10,
          left: "56px",
          width: "64px",
          height: "64px",
          color: Colors.PrimaryContrast,
        }}
      />
      {menuLinks.map((item, idx) => {
        return <DropdownLink item={item} key={`dropdown-menu-${idx}`} />;
      })}
    </Stack>
  );
};

export default DropdownMenu;
